import {
  FILTER_MATCH_TYPE_SEPARATOR,
  FILTER_VALUE_SEPARATOR,
} from '@aibees/elephant/constants/filters';
import { KeywordSources } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { useMemo } from 'react';

export function useKeywordsSourceSearchMatchSelected(
  source: KeywordSources,
  searchMatchParamValue: string | undefined
) {
  return useMemo(() => {
    const draft = searchMatchParamValue?.split(FILTER_VALUE_SEPARATOR) ?? [];
    const fieldDraft = draft.find(
      (x) => x.split(FILTER_MATCH_TYPE_SEPARATOR)[0] === source
    );
    const isExistInParams = !!fieldDraft;
    return {
      isExistInParams,
      type: fieldDraft?.split(FILTER_MATCH_TYPE_SEPARATOR)[1],
    };
  }, [searchMatchParamValue, source]);
}
